import 'bootstrap/dist/css/bootstrap.min.css';
import { useState, useEffect, useRef } from 'react';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';

import Container from 'react-bootstrap/Container';
import { Link } from "react-router-dom";
import PageFooter from "./components/pageFooter";
import { API_URL } from '../config';

import { resolveImage } from '../data/imageMap';

export function getData() {
    return [
        { id: 'nail-1', image: '/nails/nail1a.jpg', imageOnHover: '/nails/nail1b.jpeg', title: 'celestial set', description: 'medium almond + extra short round on index & middle', price: 35, defaultLength: 'Medium', defaultShape: 'Almond', gallery: ['/nails/nail1b.jpeg', '/nails/nail1a.jpg'] },
        { id: 'nail-2', image: '/nails/nail2b.jpg', imageOnHover: '/nails/nail2a.jpg', title: 'wire set', description: 'medium almond', price: 50, defaultLength: 'Medium', defaultShape: 'Almond', gallery: ['/nails/nail2b.jpg', '/nails/nail2a.jpg'] },
        { id: 'nail-3', image: '/nails/nail3b.jpg', imageOnHover: '/nails/nail3a.jpg', title: 'renaissance set', description: 'medium almond', price: 35, defaultLength: 'Medium', defaultShape: 'Almond', gallery: ['/nails/nail3b.jpg', '/nails/nail3a.jpg'] },
        { id: 'nail-4', image: '/nails/nail4a.jpg', imageOnHover: '/nails/nail4b.JPG', title: 'lucky lucky set!', description: 'extra short round', price: 50, defaultLength: 'Extra Short', defaultShape: 'Round', gallery: ['/nails/nail4b.JPG', '/nails/nail4a.jpg'] },
        { id: 'nail-5', image: '/nails/nail5b.jpg', imageOnHover: '/nails/nail5a.jpg', title: 'diamond blush set', description: 'medium round', price: 30, defaultLength: 'Medium', defaultShape: 'Round', gallery: ['/nails/nail5b.jpg', '/nails/nail5a.jpg'] },
        { id: 'nail-7', image: '/nails/nail7b.jpeg', imageOnHover: '/nails/nail7a.jpg', title: 'naruto set', description: 'medium almond', price: 50, defaultLength: 'Medium', defaultShape: 'Almond', gallery: ['/nails/nail7b.jpeg', '/nails/nail7a.jpg'] },
        { id: 'fruits-1', image: '/nails/fruit1b.jpeg', imageOnHover: '/nails/fruits1a.png', title: 'fruits set', description: 'short stiletto', price: 35, defaultLength: 'Short', defaultShape: 'Stiletto', gallery: ['/nails/fruit1b.jpeg', '/nails/fruits1a.png'] },
        { id: 'fruits-2', image: '/nails/fruit2b.jpeg', imageOnHover: '/nails/fruits2a.jpeg', title: 'mini mini fruits set!', description: 'short stiletto', price: 35, defaultLength: 'Short', defaultShape: 'Stiletto', gallery: ['/nails/fruit2b.jpeg', '/nails/fruits2a.jpeg'] },
        { id: 'fruits-3', image: '/nails/fruit3b.jpeg', imageOnHover: '/nails/fruits3a.png', title: 'apple apple set', description: 'short stiletto', price: 35, defaultLength: 'Short', defaultShape: 'Stiletto', gallery: ['/nails/fruit3b.jpeg', '/nails/fruits3a.png'] },
        { id: 'kiki-1', image: '/nails/kiki1b.jpeg', imageOnHover: '/nails/kiki1a.png', title: 'kiki set', description: 'medium round', price: 45, defaultLength: 'Medium', defaultShape: 'Round', gallery: ['/nails/kiki1b.jpeg', '/nails/kiki1a.png'] },
        { id: 'miffy-1', image: '/nails/miffy1a.png', imageOnHover: '/nails/miffy1b.jpeg', title: 'miffy set', description: 'medium round', price: 45, defaultLength: 'Medium', defaultShape: 'Round' },
        { id: 'smiski-1', image: '/nails/smiski1b.jpeg', imageOnHover: '/nails/smiski1a.jpg', title: 'smiski set', description: 'short stiletto', price: 40, defaultLength: 'Short', defaultShape: 'Stiletto', gallery: ['/nails/smiski1b.jpeg', '/nails/smiski1a.jpg'] },
        { id: 'star-1', image: '/nails/star1b.jpeg', imageOnHover: '/nails/star1a.png', title: 'star set', description: 'medium almond', price: 55, defaultLength: 'Medium', defaultShape: 'Almond', gallery: ['/nails/star1b.jpeg', '/nails/star1a.png'] },
        { id: 'strawberry-1', image: '/nails/strawberry1b.png', imageOnHover: '/nails/strawberry1a.jpeg', title: 'strawberry set', description: 'extra short round', price: 45, defaultLength: 'Extra Short', defaultShape: 'Round', gallery: ['/nails/strawberry1b.png', '/nails/strawberry1a.jpeg'] },
        { id: 'tomato-1', image: '/nails/tomato1b.jpeg', imageOnHover: '/nails/tomato1b.jpeg', title: 'tomato set', description: 'medium round', price: 35, defaultLength: 'Medium', defaultShape: 'Round' },
        { id: 'totoro-1', image: '/nails/totoro1a.jpeg', imageOnHover: '/nails/totoro1a.jpeg', title: 'totoro set', description: 'medium round', price: 45, defaultLength: 'Medium', defaultShape: 'Round' },
        { id: 'chromehearts-1', image: '/nails/chromehearts1b.jpeg', imageOnHover: '/nails/chromehearts1a.jpg', title: 'chrome hearts set', description: 'medium stiletto', price: 60, defaultLength: 'Medium', defaultShape: 'Stiletto', gallery: ['/nails/chromehearts1b.jpeg', '/nails/chromehearts1a.jpg'] },
        { id: 'flower-1', image: '/nails/flower1b.jpeg', imageOnHover: '/nails/flower1a.png', title: 'fairy set', description: 'medium stiletto', price: 60, defaultLength: 'Medium', defaultShape: 'Stiletto', gallery: ['/nails/flower1b.jpeg', '/nails/flower1a.png'] },
        { id: 'flower-2', image: '/nails/flower2c.jpg', imageOnHover: '/nails/flower2a.png', title: 'flower set', description: 'short round', price: 45, defaultLength: 'Short', defaultShape: 'Round', gallery: ['/nails/flower2c.jpg', '/nails/flower2a.png'] },
    ];
}

export function getPrintsData() {
    const details = 'printed on high-quality cardstock · ships in a protective sleeve · original digital illustration by egg tarty studio';
    return [
        { id: 'print-roses', image: '/prints/roses.png', imageOnHover: '/prints/roses.png', title: "mom's flowers", price: 12, size: '4 x 6 in', size2: '8.5 x 11 in', description: 'art print by egg tarty', details },
        { id: 'print-7', image: '/prints/artwork6.jpg', imageOnHover: '/prints/artwork6.jpg', title: "grandma's house", price: 12, size: '5 x 7 in', size2: '8 x 10 in', description: 'art print by egg tarty', details, border: true },
        { id: 'print-8', image: '/prints/bunnyart.jpg', imageOnHover: '/prints/bunnyart.jpg', title: 'bunny takes a nap', price: 12, size: '5 x 7 in', size2: '8 x 10 in', description: 'art print by egg tarty', details },
        { id: 'print-0', image: '/prints/artwork0.jpg', imageOnHover: '/prints/artwork0.jpg', title: 'picnic with mocha & bunny!', price: 12, size: '4 x 6 in', size2: '8 x 10 in', description: 'art print by egg tarty', details },
        { id: 'print-3', image: '/prints/artwork1.png', imageOnHover: '/prints/artwork1.png', title: 'mocha the wrangler', price: 12, size: '4 x 6 in', size2: '8 x 10 in', description: 'art print by egg tarty', details, cover: true },
        { id: 'print-4', image: '/prints/artwork3.jpg', imageOnHover: '/prints/artwork3.jpg', title: 'lets get ready for the party', price: 12, size: '5 x 7 in', size2: '8 x 10 in', description: 'art print by egg tarty', details },
        { id: 'print-5', image: '/prints/artwork4.jpg', imageOnHover: '/prints/artwork4.jpg', title: 'kitty & friends', price: 12, size: '4 x 5 in', size2: '8 x 10 in', description: 'art print by egg tarty', details, cover: true },
        { id: 'print-6', image: '/prints/Miffys_Lesson.png', imageOnHover: '/prints/Miffys_Lesson.png', title: "miffy's lesson", price: 12, size: '5 x 7 in', size2: '8 x 10 in', description: 'art print by egg tarty', details },
        { id: 'print-lklkl', image: '/prints/lklkl.png', imageOnHover: '/prints/lklkl.png', title: 'mochas cozy winter day', price: 12, size: '4 x 6 in', size2: '8 x 10 in', description: 'art print by egg tarty', details },
        { id: 'print-mknkn', image: '/prints/mknkn.png', imageOnHover: '/prints/mknkn.png', title: 'time to sleep mocha!', price: 12, size: '4 x 6 in', size2: '8 x 10 in', description: 'art print by egg tarty', details },
        { id: 'print-zxzxz', image: '/prints/zxzxz.png', imageOnHover: '/prints/zxzxz.png', title: "mochas lucky day", price: 12, size: '4 x 6 in', size2: '8 x 10 in', description: 'art print by egg tarty', details },
    ];
}

export function getStickersData() {
    const d = 'matte sticker· waterproof & durable · designed by egg tarty studio';
    return [
        { id: 'sticker-2', image: '/stickers/artwork3.png', imageOnHover: '/stickers/artwork3.png', title: 'cowboys do cry', price: 4, size: '3x3in', description: 'illustrated sticker sheet', details: d },
        { id: 'sticker-3', image: '/stickers/artwork4.png', imageOnHover: '/stickers/artwork4.png', title: 'i miss my cat', price: 4, size: '3x3in', description: 'illustrated sticker sheet', details: d },
        { id: 'sticker-6', image: '/stickers/sticker6.png', imageOnHover: '/stickers/sticker6.png', title: 'im not cute anymore !', price: 4, size: '3x3in', description: 'illustrated sticker sheet', details: d },
        { id: 'sticker-7', image: '/stickers/sticker7.png', imageOnHover: '/stickers/sticker7.png', title: 'mocha', price: 4, size: '3x3in', description: 'illustrated sticker sheet', details: d },
        { id: 'sticker-8', image: '/stickers/sticker8.png', imageOnHover: '/stickers/sticker8.png', title: 'bunny starts a band! hes a singer!', price: 4, size: '3x3in', description: 'illustrated sticker sheet', details: d },
        { id: 'sticker-9', image: '/stickers/sticker9.png', imageOnHover: '/stickers/sticker9.png', title: 'bunny starts a band! hes a drummer!', price: 4, size: '3x3in', description: 'illustrated sticker sheet', details: d },
        { id: 'sticker-11', image: '/stickers/sticker11.png', imageOnHover: '/stickers/sticker11.png', title: 'bunny starts a band! hes a guitarist!', price: 4, size: '3x3in', description: 'illustrated sticker sheet', details: d },
    ];
}

export function getSheetsData() {
    return [
        { id: 'sticker-cowboy', image: '/stickers/sheets/cowboysticker.png', imageOnHover: '/stickers/sheets/cowboysticker.png', title: 'mocha the wrangler', price: 8, size: '4 x 6 in', description: 'illustrated sticker sheet', details: '14 clear, matte stickers · waterproof & durable · designed by egg tarty studio', sheet: true },
        { id: 'sticker-sleeping', image: '/stickers/sheets/sleepingsticker.png', imageOnHover: '/stickers/sheets/sleepingsticker.png', title: 'its time to sleep mocha', price: 8, size: '4 x 6 in', description: 'illustrated sticker sheet', details: '14 clear, matte stickers · waterproof & durable · designed by egg tarty studio', sheet: true },
        { id: 'sticker-bunny', image: '/stickers/sheets/bunnysticker.png', imageOnHover: '/stickers/sheets/bunnysticker.png', title: 'new years with bunny', price: 8, size: '4 x 6 in', description: 'illustrated sticker sheet', details: '14 clear, matte stickers · waterproof & durable · designed by egg tarty studio', sheet: true },
        { id: 'sticker-grandma', image: '/stickers/Untitled_Artwork.png', imageOnHover: '/stickers/Untitled_Artwork.png', title: "grandma's house ii", price: 8, size: '4 x 6 in', description: 'illustrated sticker sheet', details: '14 clear, matte stickers · waterproof & durable · designed by egg tarty studio' },
        { id: 'sheet-mocha', image: '/stickers/sheets/Mocha_Sitting_Final_No_1.png', imageOnHover: '/stickers/sheets/Mocha_Sitting_Final_No_1.png', title: "mochas lucky day", price: 8, size: '4 x 6 in', description: 'illustrated sticker sheet', details: '14 clear, matte stickers · waterproof & durable · designed by egg tarty studio', sheet: true },
        { id: 'sheet-movha', image: '/stickers/sheets/Movha_Snowboarder_Final_No_1.png', imageOnHover: '/stickers/sheets/Movha_Snowboarder_Final_No_1.png', title: 'mochas cozy winter day', price: 8, size: '4 x 6 in', description: 'illustrated sticker sheet', details: '17 clear, matte stickers · waterproof & durable · designed by egg tarty studio', sheet: true },
    ];
}

export function getAccessoriesData() {
    return [
        {
            id: 'crochet-1',
            image: '/crochet/crocet1a.jpeg',
            imageOnHover: '/crochet/crocet1a.jpeg',
            title: 'Crochet Print Border',
            price: 25,
            size: '5 x 7 in',
            description: 'handmade crochet frame',
            details: 'crochet frame made to fit a 4x6in print. ',
        },
    ];
}

const toSlug = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const saveScroll = () => {
    const pageBody = document.querySelector('.pageBody');
    if (pageBody) sessionStorage.setItem('shopScroll', pageBody.scrollTop);
};

const ProductContent = ({ data, activeTab }) => {
    const category = activeTab === 'nails' ? 'nails' : activeTab;
    const slug = toSlug(data.title);

    if (activeTab === 'prints') {
        return (
            <Link to={`/shop/${category}/${slug}`} className='printCard' onClick={saveScroll}>
                <img className='printCardImage' src={resolveImage(data.image)} alt={data.title} draggable={false} onContextMenu={e => e.preventDefault()} loading="lazy" />
                <div className='printCardInfo'>
                    <span className='printCardTitle'>{data.title}</span>
                    <span className='printCardPrice'>starting at ${data.price}</span>
                </div>
            </Link>
        );
    }

    if (activeTab === 'stickers') {
        return (
            <Link to={`/shop/${category}/${slug}`} className='stickerCard' onClick={saveScroll}>
                <div className='stickerCardImageWrap'>
                    <img className='stickerCardImage' style={{ objectFit: data.sheet ? 'cover' : 'contain' }} src={resolveImage(data.image)} alt={data.title} draggable={false} onContextMenu={e => e.preventDefault()} loading="lazy" />
                </div>
                <div className='stickerCardInfo'>
                    <span className='stickerCardTitle'>{data.title}</span>
                    <span className='stickerCardPrice'>${data.price}</span>
                </div>
            </Link>
        );
    }

    if (activeTab === 'nails') {
        return (
            <Link to={`/shop/${category}/${slug}`} className='nailCard' onClick={saveScroll}>
                <div className='nailCardImageWrap'>
                    <img className='nailCardImage nailCardImageMain' src={resolveImage(data.image)} alt={data.title} draggable={false} onContextMenu={e => e.preventDefault()} loading="lazy" />
                    <img className='nailCardImage nailCardImageHover' src={resolveImage(data.imageOnHover)} alt={data.title} draggable={false} onContextMenu={e => e.preventDefault()} loading="lazy" />
                    {data.soldOut && <div className='soldOutBadge'>sold out</div>}
                </div>
                <div className='nailCardInfo'>
                    <span className='nailCardTitle'>{data.title}</span>
                    <span className='nailCardPrice'>${data.price}</span>
                </div>
            </Link>
        );
    }

    // crochet / fallback — same card style
    return (
        <Link to={`/shop/${category}/${slug}`} className='nailCard' onClick={saveScroll}>
            <div className='nailCardImageWrap'>
                <img className='nailCardImage nailCardImageMain' src={resolveImage(data.image)} alt={data.title} draggable={false} onContextMenu={e => e.preventDefault()} loading="lazy" />
                <img className='nailCardImage nailCardImageHover' src={resolveImage(data.imageOnHover)} alt={data.title} draggable={false} onContextMenu={e => e.preventDefault()} loading="lazy" />
                {data.soldOut && <div className='soldOutBadge'>sold out</div>}
            </div>
            <div className='nailCardInfo'>
                <span className='nailCardTitle'>{data.title}</span>
                <span className='nailCardPrice'>${data.price}</span>
            </div>
        </Link>
    );
};

const Products = () => {
    const [nailSlots, setNailSlots] = useState(null);
    const [activeTab, setActiveTab] = useState(
        () => sessionStorage.getItem('shopTab') || 'prints'
    );

    const gridRef = useRef(null);

    useEffect(() => {
        fetch(`${API_URL}/api/inventory`)
            .then((r) => r.json())
            .then((d) => setNailSlots(d.nailSlots ?? 5))
            .catch(() => {});
    }, []);

    // Restore scroll position when returning to shop
    useEffect(() => {
        const saved = sessionStorage.getItem('shopScroll');
        if (saved && gridRef.current) {
            const pageBody = gridRef.current.closest('.pageBody');
            if (pageBody) pageBody.scrollTop = parseInt(saved, 10);
            sessionStorage.removeItem('shopScroll');
        }
    }, []);

    const handleTabChange = (key) => {
        setActiveTab(key);
        sessionStorage.setItem('shopTab', key);
        // reset scroll when switching tabs
        const pageBody = gridRef.current?.closest('.pageBody');
        if (pageBody) pageBody.scrollTop = 0;
    };

    const nailsSoldOut = nailSlots !== null && nailSlots <= 0;
    const nails = getData().map((p) => ({ ...p, soldOut: nailsSoldOut }));
    const prints = getPrintsData();
    const stickers = getStickersData();
    const accessories = getAccessoriesData();
    const sheets = getSheetsData();

    const tabs = [
        { key: 'prints', label: 'prints' },
        { key: 'stickers', label: 'stickers' },
        { key: 'nails', label: 'press-ons' },
        { key: 'crochet', label: 'crochet' },
    ];

    const productMap = {
        nails,
        prints,
        stickers: [...sheets, ...stickers],
        crochet: accessories,
    };

    const gridClass = {
        nails: 'nailGrid',
        prints: 'printGrid',
        stickers: 'stickerGrid',
        crochet: 'nailGrid',
    }[activeTab] || 'masonryGrid';

    return (
        <Container fluid className={'productPageContainer'} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div className="shopTabBar">
                {tabs.map((t) => (
                    <button
                        key={t.key}
                        className={`shopTab${activeTab === t.key ? ' shopTabActive' : ''}`}
                        onClick={() => handleTabChange(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
            <div className={gridClass} ref={gridRef}>
                {productMap[activeTab].map((object, i) => (
                    <ProductContent key={i} data={object} activeTab={activeTab} />
                ))}
                {activeTab === 'nails' && (
                    <Link to="/shop/custom-commission" className='nailCard' onClick={saveScroll}>
                        <div className='nailCardImageWrap'>
                            <img className='nailCardImage nailCardImageMain' src={require("../images/nails/custom.jpeg")} alt="custom commission" />
                            <img className='nailCardImage nailCardImageHover' src={require("../images/nails/custom.jpeg")} alt="custom commission" />
                        </div>
                        <div className='nailCardInfo'>
                            <span className='nailCardTitle'>custom commission</span>
                            <span className='nailCardPrice'>inquire</span>
                        </div>
                    </Link>
                )}
            </div>
        </Container>
    );
};

export const ProductPage = () => {
    return (
        <PageLayout>
            <PageContainer>
                <PageBody>
                    <NavigationHeader />
                    <PageText>
                        <Products />
                    </PageText>
                    <PageFooter />
                </PageBody>
            </PageContainer>
        </PageLayout>
    );
};
